import { lazy, type ComponentType } from 'react';

/**
 * `React.lazy` + qayta urinish.
 *
 * Sahifalar alohida bo'laklarga ajratildi (asosiy fayl 1.37 MB edi —
 * O'zbekistondan Frankfurtgacha sekin yo'lda 20 soniya). Lekin shu yo'l
 * paket ham yo'qotadi: bo'lak bir marta kelmay qolsa, oddiy `lazy`
 * darhol xato beradi va o'quvchi bo'sh sahifa ko'radi. Shuning uchun
 * ikki marta qayta urinamiz.
 */
export function lazyWithRetry<T extends ComponentType<any>>(
  load: () => Promise<T>,
  retries = 2,
) {
  return lazy(async () => {
    for (let attempt = 0; ; attempt++) {
      try {
        return { default: await load() };
      } catch (e) {
        if (attempt >= retries) throw e;
        await new Promise((r) => setTimeout(r, 800 * (attempt + 1)));
      }
    }
  });
}
